import { useEffect } from "react";

export default function ScrollToTop({page}) {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return null;
}